<template>
  <div v-if="allTaxLineOptions.length !== 0" class="m-b-10">
    <div class="row col-sm-12 m-b-10">
      <transition name="expand">
        <a
          v-show="!showSalesTax"
          v-tooltip="$t('Add sales tax for your bill')"
          href="#"
          @click.prevent="addNewLine"
        >
          <span class="label label-sm bgm-lightgray f-13 f-500 c-indigo">
            {{ $t('Add sales tax') }}
          </span>
        </a>
      </transition>
    </div>
    <transition name="showSalesTax">
      <div v-show="showSalesTax">
        <div
          v-for="(selectedTaxLine, index) in selectedTaxLines"
          :key="selectedTaxLine.taxLine.name"
          class="row m-b-10"
        >
          <div class="col-sm-4">
            <select v-model="selectedTaxLine.taxLine" class="fullwidth form-control">
              <option
                v-for="{ taxLine } in [selectedTaxLine, ...availableTaxLines]"
                :key="taxLine.name"
                :value="taxLine"
              >
                {{ taxLine.name }}
              </option>
            </select>
          </div>

          <div class="col-sm-4">
            <input
              :name="`taxLines[${selectedTaxLine.taxLine.name}]`"
              :value="selectedTaxLine.percentage / 100"
              hidden
            />
            <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
            <input-percentage
              v-model="selectedTaxLine.percentage"
              :fraction-max-value="999"
              :decimals="3"
              fraction-placeholder="000"
            />
          </div>

          <div
            v-if="hasAvailableTaxLines && index === selectedTaxLines.length - 1"
            class="col-sm-4 p-t-10"
          >
            <a
              :title="$t('Add additional sales tax lines')"
              href="#"
              data-toggle="tooltip"
              @click.prevent="addNewLine"
            >
              <span class="label label-sm bgm-lightgray f-13 f-500 c-indigo">
                {{ $t('Add additional sales tax') }}
              </span>
            </a>
          </div>
        </div>
      </div>
    </transition>
    <slot name="help"></slot>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    yjobId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedTaxLines: [],
      allTaxLineOptions: [],
    }
  },
  computed: {
    showSalesTax() {
      return !!this.selectedTaxLines.length
    },
    availableTaxLines() {
      return this.allTaxLineOptions
        .filter(
          (taxLine) =>
            !this.selectedTaxLines
              .map((selectedTaxLine) => selectedTaxLine.taxLine.name)
              .includes(taxLine.name),
        )
        .map((taxLineOption) => ({
          taxLine: { ...taxLineOption },
          percentage: null,
        }))
    },
    hasAvailableTaxLines() {
      return !!this.availableTaxLines.length
    },
  },
  created() {
    this.getTaxLineOptions().then(() => this.getPreviousTaxLineValues())
  },
  methods: {
    addNewLine() {
      if (this.availableTaxLines.length) {
        this.selectedTaxLines.push(this.availableTaxLines[0])
      }
    },
    async getTaxLineOptions() {
      return this.$apollo
        .query({
          query: gql`
            query TaxLineOptions($yjobId: ID!) {
              taxLineOptions(yjob_id: $yjobId) {
                name
              }
            }
          `,
          variables: {
            yjobId: this.yjobId,
          },
        })
        .then((result) => {
          this.allTaxLineOptions = result.data?.taxLineOptions || []
        })
    },
    getPreviousTaxLineValues() {
      this.$apollo
        .query({
          query: gql`
            query PreviousTaxLineValues {
              viewerAccount {
                ... on Freelancer {
                  bills(first: 1, orderBy: { field: CREATED_AT, order: DESC }) {
                    data {
                      globalId
                      tax_lines {
                        name
                        value
                      }
                    }
                  }
                }
              }
            }
          `,
        })
        .then((result) => {
          const previousTaxLines = result.data?.viewerAccount?.bills?.data?.[0]?.tax_lines

          if (!previousTaxLines) {
            return
          }

          previousTaxLines.forEach((previousTaxLine) => {
            const matchingTaxLine = this.allTaxLineOptions.find(
              (taxLineOption) => taxLineOption.name === previousTaxLine.name,
            )

            if (matchingTaxLine) {
              this.selectedTaxLines.push({
                taxLine: { name: matchingTaxLine.name },
                percentage: previousTaxLine.value,
              })
            }
          })
        })
    },
  },
}
</script>

<style scoped lang="scss"></style>
